module.exports = __webpack_public_path__ + "static/media/no_client_connections.0fbd01d0.png";